import type { ITickerTextProps } from '../types';
import { useScrambleText } from './hooks';

const TickerText = ({ targetText, duration = 2000, delay = 700 }: ITickerTextProps) => {
  const displayText = useScrambleText(targetText, duration, delay);

  return <span>{displayText}</span>;
};

export default TickerText;
